import { useAppDispatch } from 'src/app/store/hooks';
import {
  DriverDriverTagRead,
  useDriverTagsDestroyMutation,
} from 'src/common/external/bambi-api/bambiApi';
import { toastSlice } from 'src/common/primitives/Toast/toast.slice';
import { TagDisplay } from 'src/common/tags/TagDisplay/TagDisplay';

interface DriverTagsDisplayProps {
  tags?: DriverDriverTagRead[] | null;
}

export default function DriverTagsDisplay({
  tags,
}: DriverTagsDisplayProps): JSX.Element | null {
  const dispatch = useAppDispatch();
  const [deleteTag] = useDriverTagsDestroyMutation();

  return (
    <TagDisplay
      tags={tags}
      onDelete={(tagId) => {
        return deleteTag({
          id: tagId,
        })
          .unwrap()
          .catch(() => {
            dispatch(
              toastSlice.actions.show({
                title: 'Error deleting tag',
                type: 'error',
              })
            );
          });
      }}
    />
  );
}
